// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lole-site-container{display:flex;flex-direction:column;height:100%;width:100%}.lole-site-content-container{display:flex;flex:1 1 0%;flex-direction:column;height:100%;margin-left:auto;margin-right:auto;max-width:1920px;max-width:192rem;position:relative;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
